namespace $.$$ {

	$mol_style_define( $bog_pazzle_saves, {

		display: 'flex',
		flexDirection: 'column',
		gap: $mol_gap.block,

		Empty: {
			color: $mol_theme.shade,
			padding: $mol_gap.block,
			textAlign: 'center',
		},

		Create: {
			justifyContent: 'center',
			gap: $mol_gap.text,
		},

	} )

}
